module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy2"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("StuG III Brigade 191, 1940–1945: The Buffalo Brigade in Action in the Balkans, Greece and from Moscow to Kursk and Sevastopol")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/copy.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("First published by Greenhill Books, 2021")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Greenhill Books, c/o Pen & Sword Books Ltd, 47 Church Street, Barnsley, S. Yorkshire, S70 2AS")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("For more information on our books, please visit "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.greenhillbooks.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.greenhillbooks.com")])])]), _vm._v(", email "), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "mailto:contact@greenhillbooks.com"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("contact@greenhillbooks.com")])])]), _vm._v(" or write to us at the above address.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Copyright © Verlagshaus Würzburg GmbH & Co. KG")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Flechsig Verlag, Beethovenstraße 5B, D-97080 Würzburg, Germany")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    attrs: {
      "href": "http://www.verlagshaus.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("www.verlagshaus.com")])])])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("This edition © Greenhill Books, 2021")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Anthony Tucker-Jones foreword © Greenhill Books, 2021")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("PUBLISHING HISTORY")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("StuG III Brigade 191, 1940–1945")]), _vm._v(" was originally published in 1977 by Verlagshaus Würzburg GmbH & Co. KG with the title "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Die Sturmgeschützbrigade 191: Die ‘Büffelbrigade’ im Einsatz auf dem Balkan und in den Weiten Russlands 1940–1945")]), _vm._v(", with a revised edition in 2009. This edition has a new foreword by Anthony Tucker-Jones.")]), _vm._v(" "), _c('p', {
    staticClass: "copy3"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording or otherwise) without the prior written permission of the publisher. Any person who does any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("CIP data records for this title are available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 978-1-78438-695-5")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("eISBN 978-1-78438-696-2")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e620bc9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Copyright.vue
// module id = 63
// module chunks = 0